module.exports = require("skypager-util");


//////////////////
// WEBPACK FOOTER
// external "skypager-util"
// module id = 16
// module chunks = 0